import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getSectorIndustry = () => {
  return axiosPrivate.get(`/dashboard/api/v1/sector-industry`);
};
